import HomeIcon from '@mui/icons-material/Home';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import SearchIcon from '@mui/icons-material/Search';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import { USER_ROLES } from '../../constants/userRoles';

export const NAV_ITEMS_BY_ROLE = {
  [USER_ROLES.PACIENTE]: [
    { Icon: HomeIcon, label: 'Inicio', to: '/' },
    { Icon: CalendarMonthIcon, label: 'Mis Turnos', to: '/turnos' },
    { Icon: SearchIcon, label: 'Buscar Turnos', to: '/buscar-turnos' },
    { Icon: MedicalServicesIcon, label: 'Historial', to: '/turnos/historial' },
  ],
  [USER_ROLES.MEDICO]: [
    { Icon: HomeIcon, label: 'Inicio', to: '/' },
    { Icon: CalendarMonthIcon, label: 'Agenda', to: '/agenda' },
    { Icon: MedicalServicesIcon, label: 'Servicios', to: '/servicios' },
    { Icon: LocationOnIcon, label: 'Sedes', to: '/sedes' },
    { Icon: EventAvailableIcon, label: 'Disponibilidades', to: '/disponibilidades' },
  ],
};
